var exports = {
  "k": "x43aef4ae--995047--container",
};

module.exports = exports;
